import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TokenService } from '../services/helpers/token.service';

export const beforeLoginGuard: CanActivateFn = () => {
  return !inject(TokenService).isUserloggedIn();
};
